import React, { useState, useEffect, useContext } from 'react'
import Axios from 'axios'
import { firestore } from '../../../../firebase'
import { isToday } from '../../../../helpers/dateFormatter'
import StateContext from '../../../../StateContext'
import Loader from '../../../Loader/Loader'
import UserFavoritedFixturesAPI from '../../../Profile/UserFavoritedFixturesAPI'
import ScrollView from '../../../ScrollView/ScrollView'
import UtenlandsProfferScrollTemplate from '../../UtenlandsProffer/templates/UtenlandsProfferScrollTemplate'
import AllLeaguesLive from './FixtureTemplates/AllLeaguesLive'
import FavoriteLeaguesLive from './FixtureTemplates/FavoriteLeaguesLive'
import FavoriteTeamsLive from './FixtureTemplates/FavoriteTeamsLive'
import FixtureDateHandler from './FixtureTemplates/FixtureDateHandler/FixtureDateHandler'
import FixturesByDate from './FixtureTemplates/FixturesByDate'
import FixturesLiveNow from './FixtureTemplates/FixturesLiveNow'
import LiveFixturesByDate from './FixtureTemplates/LiveFixturesByDate'

function Fixtures({ type }) {
    const appState = useContext(StateContext)

    const [leagues, setLeagues] = useState([])
    const [leagueIds, setLeagueIds] = useState([])
    const [dateFormatted, setDateFormatted] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [allFixtures, setAllFixtures] = useState([])
    const [topFixtures, setTopFixtures] = useState([])
    const [requestCount, setRequestCount] = useState(0)
    const [requestInterval, setRequestInterval] = useState(30000)

    function initializeDate() {
        if (localStorage.getItem('date_selected')) {
            return localStorage.getItem('date_selected')
        }
        const today = new Date()
        let day = today.getDate(),
            month = today.getMonth() + 1
        month = today.getMonth() + 1
        if (month < 10) {
            month = `0${month}`
        } else {
            month = month
        }
        if (today.getDate() < 10) {
            day = `0${today.getDate()}`
        } else {
            day = today.getDate()
        }
        console.log(day, 'DAY')
        const todayFormattedUTC = `${today.getFullYear()}-${month}-${day}`
        return todayFormattedUTC
    }

    const todayFormattedUTC = initializeDate()

    const [date, setDate] = useState(todayFormattedUTC)
    const [dayFixture, setDayFixture] = useState(0)

    useEffect(() => {
        if (date && dayFixture) {
            let day, month
            const dateSelected = new Date(date)
            if (dateSelected.getMonth() + 1 < 10) {
                month = `0${dateSelected.getMonth() + 1}`
            } else {
                month = month
            }
            if (dateSelected.getDate() < 10) {
                day = `0${dateSelected.getDate()}`
            } else {
                day = dateSelected.getDate()
            }
            const dateSelectedApi = `${dateSelected.getFullYear()}-${month}-${dayFixture}`
            setDateFormatted(dateSelectedApi)
        }
    }, [date])

    useEffect(() => {
        async function getData() {
            const URL = 'https://backend-stats-app.herokuapp.com/league/leagues'
            const response = await Axios.get(URL)
            console.log(response.data, 'TOP LEAGUES API')
            const leagueIds = response?.data?.map((league) => {
                return +league.league_id
            })
            setLeagueIds(leagueIds)
            console.log(leagueIds)
            setLeagues(response.data)
        }
        getData()
    }, [])

    /* useEffect(() => {
        try {
            const leaguesRef = firestore.collection('top-leagues')
            leaguesRef.orderBy('order').onSnapshot(({ docs }) => {
                const leagues = docs.map((doc) => {
                    const leagues = { id: doc.id, ...doc.data() }
                    return leagues
                })
                const leagueIds = leagues.map((league) => {
                    return +league.league_id
                })
                setLeagueIds(leagueIds)
                setLeagues(leagues)
            })
        } catch (error) {
            console.log(error)
        }
    }, []) */

    useEffect(() => {
        if (isToday(date)) {
            const interval = setInterval(() => {
                setRequestCount((requestCount) => requestCount + 1)
            }, requestInterval)
            return () => clearInterval(interval)
        }
    }, [date])

    useEffect(() => {
        const allLeaguesLive = allFixtures.map((fixture) => {
            return {
                league_id: fixture.league_id,
                league_name: fixture.league.name,
                league_logo: fixture.league.logo,
            }
        })

        if (leagueIds) {
            const fixturesLeagues = filterFixtures(allFixtures, 2790, leagueIds)
            setTopFixtures(fixturesLeagues)
        }
        console.log(leagueIds)
    }, [leagueIds, allFixtures])

    function filterFixtures(allFixturesDate, leagueId, myLeagueIds) {
        // Filter out unwanted leagues

        const fixtures = allFixturesDate.filter((league) => {
            //console.log(+league.league_id, "==", +leagueId)

            return myLeagueIds.includes(league.league_id)

            //return +league.league_id === +leagueId
        })

        return fixtures
    }

    function filterFixturesLeague(allFixturesDate, leagueId) {
        const leagueFixtures = allFixturesDate.filter((league) => {
            return +league.league_id === +leagueId
        })
        console.log(leagueFixtures, leagueFixtures, 99999999999999)
        return leagueFixtures
    }

    return (
        <div className="py-4">
            <FixtureDateHandler date={date} setDate={setDate} />
            <UtenlandsProfferScrollTemplate
                allFixtures={allFixtures}
                type={type}
            />
            <FixturesByDate
                date={date}
                type={type}
                allFixtures={allFixtures}
                setAllFixtures={setAllFixtures}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
            />
            <FixturesLiveNow type={type} requestCount={requestCount} />
            {isLoading && (
                <div className="my-4">
                    <Loader />
                </div>
            )}
            {appState.loggedIn && (
                <React.Fragment>
                    <UserFavoritedFixturesAPI
                        type={type}
                        allFixtures={allFixtures}
                    />
                    <FavoriteTeamsLive
                        date={date}
                        type={type}
                        allFixtures={allFixtures}
                    />
                    <FavoriteLeaguesLive
                        date={date}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        type={type}
                        allFixtures={allFixtures}
                    />
                </React.Fragment>
            )}

            <div className="my-3">
                <small>Toppligaer</small>
            </div>
            {leagues &&
                topFixtures?.length &&
                leagues?.map((league, index) => {
                    const leagueFixtures = filterFixturesLeague(
                        topFixtures,
                        league.league_id
                    )

                    return (
                        <LiveFixturesByDate
                            key={index}
                            leagueId={league.league_id}
                            leagueName={league.league_name}
                            leagueLogo={league.league_logo}
                            date={date}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            type={type}
                            leagueFixtures={leagueFixtures}
                        />
                    )
                })}
            <AllLeaguesLive allFixtures={allFixtures} date={date} type={type} />
        </div>
    )
}
export default Fixtures
